<script setup lang="ts">
import { Icon } from '@iconify/vue'

const props = defineProps<{
  empty: boolean
  loading: boolean
  finished: boolean
  emptyText?: string
}>()
</script>
<template>
  <div v-if="loading" class="h-full flex items-center justify-center text-center py-4 text-white/50 text-sm">
    <van-loading color="var(--color-primary)" />
  </div>
  <div v-else-if="finished && !empty" class="text-center py-4 text-white/50 text-sm">
    <div class="flex justify-center">
      <van-divider class="w-1/3 max-w-32">●</van-divider>
    </div>
  </div>
  <div
    v-else-if="empty && !loading"
    class="text-center text-gray-400 py-20 h-full flex flex-col items-center justify-center gap-4"
  >
    <icon icon="solar:layers-line-duotone" class="mx-auto mb-4 text-6xl text-gray-600" />
    <p class="text-gray-400">{{ emptyText || $t('component.dataFeedback.empty') }}</p>
  </div>
</template>
